import React, { useEffect, useContext, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { useLocation, useHistory } from "react-router-dom";

import ServerDown from "App/common/ui/ServerDown";
import Loader from "App/common/ui/Loader";
import Notify from "App/common/ui/Notify";
import Tooltip from "App/common/ui/Tooltip";
import { forbidExtraProps } from "utils";
import { HELPERS, STATIC_URLS, TOOLTIPS } from "consts";
import Machines from "./Machines";
import {
  fetchVMsListStart,
  fetchTaskStatusListStart,
  fetchGroupsStart,
  fetchVirtUserInfoStart,
  resetSliderConfigs
} from "store/actions";
import { LayoutContext } from "App/common/hoc/Layout";
import { ReactComponent as VirtualizationEmpty } from "assets/images/app_svg/virtualization_empty.svg";
import { ReactComponent as BulletPointTicks } from "assets/images/app_svg/bullet_point_ticks.svg";

function Virtualization(props) {
  const { lMethods } = useContext(LayoutContext);
  const history = useHistory();
  const location = useLocation();
  const [disableBuildVMButton, setDisabledBuildVMButton] = useState({
    disable: false,
    msg: ""
  });
  const [availableRamVI, setAvailableRamVI] = useState({
    ram: 17179869184,
    vi: 4
  });

  const [notification, setNotification] = useState({
    show: false,
    params: null
  });
  const showNotification = params =>
    setNotification({ show: true, params: params });

  const closeNotification = () => setNotification({ show: false });

  useEffect(() => {
    if (props.notification.virtualization)
      showNotification(props.notification.virtualization);
    else closeNotification();
  }, [props.notification]);

  useEffect(() => {
    props.resetSliderConfigs();
    props.fetchVMsListStart();
    props.fetchVirtUserInfoStart();
    props.fetchTaskStatusListStart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (Object.keys(props.clientsObj.list).length <= 0)
      props.fetchGroupsStart();

    if (location.state?.openAddVMSlider) {
      history.push({ ...location, state: null });
      const clientUUID = location.state?.clientUUID;
      const vm_name = location.state?.vm_name;
      location.state = null;
      lMethods.openSlidingPopup("virtualMachine", "addVirtualMachine", {
        clientUUID: clientUUID,
        vm_name: vm_name
      });
    }
  }, []);

  function calculateAvailableRam() {
    // const totalRam = 17179869184
    let ramFree = 17179869184;
    props.virtualization.vmsList.forEach(vm => {
      ramFree = ramFree - vm.memory;
    });
    return ramFree;
  }

  useEffect(() => {
    const ramFree = calculateAvailableRam();
    setAvailableRamVI({
      ram: ramFree,
      vi:
        props.virtualization.userInfo.max_virtual_machines -
        props.virtualization.vmsList.length
    });
    if (
      props.virtualization.vmsList.length >=
      props.virtualization.userInfo.max_virtual_machines
    ) {
      setDisabledBuildVMButton({
        disable: true,
        msg:
          "You can build upto " +
          props.virtualization.userInfo.max_virtual_machines +
          " virtual instances. Delete an existing virtual instance to build more."
      });
      // lMethods.closeSlidingPopup();
    } else {
      if (ramFree === 0 || ramFree < 1024 * 1024 * 1024) {
        setDisabledBuildVMButton({
          disable: true,
          msg: "Available RAM is insufficient to build a virtual instance."
        });
        // lMethods.closeSlidingPopup();
      } else {
        setDisabledBuildVMButton({ disable: false, msg: "" });
      }
    }
  }, [
    props.virtualization.vmsList,
    props.virtualization.userInfo.max_virtual_machines
  ]);

  return (
    <React.Fragment>
      <div className="fixed_container">
        <div className="container_navbar">
          <div className="inner_container_navbar">
            <div className="main_header_title">
              <h2>
                Virtualization
                {/* idrive faq */}
                {/* <p className="header_subtitle">
                  ( RemotePC-based connection mode supports real-time file
                  transfer and access on the virtual machine, and allows
                  snapshot capture.{" "}
                  <a
                    href={STATIC_URLS.rpcVirtualizationFaq.idrive}
                    className="link"
                    target="_blank"
                  >
                    Know more
                  </a>{" "}
                  )
                </p> */}
              </h2>
              {props.virtualization.vmsList.length > 0 && (
                <React.Fragment>
                  {disableBuildVMButton.disable ? (
                    <Tooltip
                      {...{
                        title: disableBuildVMButton.msg,
                        placement: "top"
                      }}
                    >
                      <div className="common_btn btn_primary btn_virtulazation btn_disable">
                        Build Virtual Instance
                      </div>
                    </Tooltip>
                  ) : (
                    <div
                      className="common_btn btn_primary btn_virtulazation"
                      onClick={() => {
                        if (!disableBuildVMButton.disable) {
                          lMethods.openSlidingPopup(
                            "virtualMachine",
                            "addVirtualMachine",
                            { ...props }
                          );
                        }
                      }}
                    >
                      Build Virtual Instance
                    </div>
                  )}
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
        {notification.show && (
          <Notify
            notify={notification}
            refresh={false}
            closeNotify={closeNotification}
            topFix={true}
          />
        )}
      </div>
      <div className="main_container_body">
        {props.virtualization.vmsList.length > 0 && (
          <div className="top_nofity_msg  ">
            {" "}
            <span className="cloud_note ">
              <strong>Note: </strong> Up to <b>16 GB</b> RAM is available for
              Cloud virtualization
              <a
                href={
                  STATIC_URLS.virtualisationFaq[
                    props?.origin === "idrive" ? "idrive" : "mirror"
                  ]
                }
                target="_blank"
              >
                {" "}
                Know more.
              </a>
            </span>
            <p class="ramsize">
              <span class="ramsize_span">
                Remaining Virtual Instances: <b>{availableRamVI.vi}</b>
              </span>
              <span class="ramsize_span">
                Remaining RAM:{" "}
                <b>{availableRamVI.ram / 1024 / 1024 / 1024} GB</b>
              </span>
            </p>
          </div>
        )}
        <div className="main_container_body__inner">
          {props.virtualization.loading ? (
            <Loader main={true} />
          ) : props.virtualization.serverDownPage.show ? (
            <ServerDown
              data={{
                status: props.virtualization.serverDownPage.status,
                msg: props.virtualization.serverDownPage.msg
              }}
            />
          ) : props.virtualization.vmsList.length > 0 ? (
            <div className="local_virtual_block">
              <Machines {...props.virtualization} />
            </div>
          ) : (
            <div className="virtualization_empty_wrap">
              <div className="virtualization_empty_wrap__inner virtualization_empty_wrap__inner_new">
                <div className="img_holder flex_center">
                  <VirtualizationEmpty />
                </div>
                <div className="empty_virtual_wrapper">
                  <h3 className="empty_heading_virtual">
                    No virtual instances to display
                  </h3>
                  <div className="ehv_box">
                    <ul>
                      <li>
                        <span className="tick_svg">
                          <BulletPointTicks />
                        </span>

                        <p className="empty_para">
                          Create up to four cloud virtual instances of your
                          Windows computer or server.{" "}
                        </p>
                      </li>
                      <li>
                        <span className="tick_svg">
                          <BulletPointTicks />
                        </span>
                        <p className="empty_para">
                          Each instance is created from a separate backup, with
                          only one instance per computer.{" "}
                        </p>
                      </li>
                      <li>
                        <span className="tick_svg">
                          <BulletPointTicks />
                        </span>
                        <p className="empty_para">
                          You can allocate up to 16 GB of RAM across instances.
                        </p>
                      </li>
                    </ul>
                  </div>
                  <div className="virtual_btn_wrap">
                    {" "}
                    <div
                      className="common_btn btn_primary btn_virtulazation"
                      onClick={() =>
                        lMethods.openSlidingPopup(
                          "virtualMachine",
                          "addVirtualMachine",
                          { ...props }
                        )
                      }
                    >
                      Build Virtual Machine
                    </div>
                    <a
                      href={
                        STATIC_URLS.virtualisationFaq[
                          props?.origin === "idrive" ? "idrive" : "mirror"
                        ]
                      }
                      target="_blank"
                    >
                      Know more{" "}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  );
}

Virtualization.propTypes = forbidExtraProps(
  {
    virtualization: PropTypes.shape({
      list: PropTypes.object
    }),
    auth: PropTypes.object,
    notification: PropTypes.object
  },
  [
    ...HELPERS.withRouter,
    "fetchVMsListStart",
    "fetchVirtUserInfoStart",
    "resetSliderConfigs"
  ]
);

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchVMsListStart,
      fetchGroupsStart,
      fetchTaskStatusListStart,
      fetchVirtUserInfoStart,
      resetSliderConfigs
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    virtualization: state.virtualization,
    auth: state.auth,
    clientsObj: state.dashboard.clients,
    notification: state.common.notification,
    origin: state.account.origin
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Virtualization);
